import { ApiBase, HttpMethod } from "../../core/api-base";
import { z } from "zod";
import { CreateItem201Response, DeleteItem200Response, UploadImage200Response } from "../../api/generated/ads.zod";

export type AdsAdminCreateResponse = z.infer<typeof CreateItem201Response>;
export type AdsAdminDeleteResponse = z.infer<typeof DeleteItem200Response>;
export type AdsAdminUploadImageResponse = z.infer<typeof UploadImage200Response>;

export interface AdsAdminUpdateResponseItem {
    ad_id?: number;
    ad_type?: string;
    ad_title?: string | null;
    ad_body?: string | null;
    link_url?: string | null;
    ad_product_id?: number | null;
    display_rate_percent?: number | null;
}

export interface AdsAdminUpdateResponse {
    success?: number;
    message?: string;
    item?: AdsAdminUpdateResponseItem;
    errors?: Record<string, string[]>;
}

export type AdsAdminCreatePayload = Record<string, unknown> & {
    ad_type: string;
    ad_title?: string;
    ad_body?: string;
    link_url?: string;
    ad_product_id?: number;
    display_rate_percent?: number;
};

export class AdsAdminApi extends ApiBase {
    public static update(form: HTMLFormElement, formData: FormData): Promise<Response> {
        return this.apiRequestWithErrorHandling(form.action, HttpMethod.Put, formData, {
            showErrors: false,
            fallbackMessage: "Ad update failed.",
        });
    }

    public static create(payload: AdsAdminCreatePayload): Promise<Response> {
        return this.apiRequestWithErrorHandling("/api/v1/ads", HttpMethod.Post, payload, {
            showErrors: false,
            fallbackMessage: "Ad create failed.",
        });
    }

    public static deleteAd(adId: number): Promise<Response> {
        return this.apiRequestWithErrorHandling(
            `/api/v1/ads/${encodeURIComponent(String(adId))}`,
            HttpMethod.Delete,
            null,
            { showErrors: false, fallbackMessage: "Ad delete failed." },
        );
    }

    public static uploadBanner(adId: number, file: File): Promise<Response> {
        const formData = new FormData();
        formData.append("ad_image", file);

        return this.apiRequestWithErrorHandling(
            `/api/v1/ads/${encodeURIComponent(String(adId))}/image`,
            HttpMethod.Post,
            formData,
            { showErrors: false, fallbackMessage: "Banner upload failed." },
        );
    }
}
